import {useContext} from 'react';

import ClinicPositionsFilter from '@/src/jobPortal/clinicPositions/containers/ClinicPositionsFilter';
import PopupContext from '@/src/popup/utils/PopupContext';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Button, Text} from '@/src/ui';

import css from '../styles/ClinicPositionsFilterPopup.module.css';

const ClinicPositionsFilterPopup = () => {
  const {closePopup} = useContext(PopupContext);

  return (
    <div className={css.modalWrapper}>
      <div className={css.title}>
        <Text
          fontSize={Text.FONT_SIZE.SIZE_24}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
        >
          <TextLocal id={'search.filters'} />
        </Text>
      </div>
      <div className={css.modalContent}>
        <ClinicPositionsFilter />
      </div>
      <div className={css.controls}>
        <Button height={Button.HEIGHT.SMALL} onClick={closePopup}>
          <TextLocal id={'search.searchForResult'} />
        </Button>
      </div>
    </div>
  );
};

export default ClinicPositionsFilterPopup;
